import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
// import { format } from "date-fns";
import { Card, CardBody, Col, Row, Container, Label, Input, Button, Form, CardHeader, InputGroup, InputGroupText, Alert } from "reactstrap";

const ViewUserPage = () => {
  const { id } = useParams(); // Extract the user ID
  const token = sessionStorage.getItem("authToken");
  // const userId = JSON.parse(sessionStorage.getItem("authUser"))._id

  const [showPassword, setShowPassword] = useState(false);
  const [showConfPassword, setShowConfPassword] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [editable, setEditable] = useState("")
  const [formData, setFormData] = useState({
    username: "",
    phone: "",
    email: "",
    password: "",
    confPassword: "",
    role: "",
  });
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const apiUrl = process.env.REACT_APP_API_BASE_URL;
        if (!apiUrl) {
          console.error("API base URL is not configured.");
          return;
        }

        // console.log(`Fetching user data from: ${apiUrl}/api/user/${id}`);

        const response = await fetch(`${apiUrl}/api/user/${id}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();

        setFormData({
          username: data.username || "",
          email: data.email || "",
          phone: data.phone || "",
          password: "",
          confPassword:  "",
          role: data.role || "",
        });
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };
    // If the id exists then call fetchData.
    if (id) fetchUserData();
  }, [id]); 
  
  // Show the error and success alerts for 5secs.
  useEffect(() => {
    const timer = setTimeout(() => {
      setError(null);
      setSuccess(null);
    }, 5000);
  
    return () => clearTimeout(timer);
  }, [error, success]);
  
  const handleSubmit = async () => {
    // e.preventDefault();
    if(editable){
      console.log("To handle form edits")
      console.log({formData})
      try{
        // Handle form submission logic here (e.g., send data to the server)
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/user/${id}`, {
          method: "PATCH",
          headers: {
            "Content-type": "application/json",
            "Authorization": `Bearer ${token}`
          },
          body: JSON.stringify(formData)
        })
        const responseData = await response.json()
        if(!response.ok) {
          console.log(responseData.err)
          setError(responseData.err)
        } else {         
          setSuccess(responseData.message)
          navigate('/users')      
        }
      } catch(error){ console.log(error.message) }
    }
    setEditable(false)
  };

  // Toggle password visibility
  const togglePasswordVisibility = () => {
      setShowPassword(!showPassword);
  };

  // Toggle password visibility
  const toggleConfPasswordVisibility = () => {
      setShowConfPassword(!showConfPassword);
  };

  return (
    <div className="page-content">
      <Container fluid={true}>
        {/* Alerts */}
        {error && <Alert color="danger" className="mt-2 mb-2">{error}</Alert>}
        {success && <Alert color="success" className="mt-2 mb-2">{success}</Alert>}
        <Row>
          {/* User Info Card */}
          <Col md={{ size: 6, offset: 3 }}>
            <Card>
              <CardBody>
                <Form>
                  {Object.keys(formData).map((key) =>
                    key === "password" || key === "confPassword" ? null : (
                      <Row className="mb-3 align-items-center" key={key}>
                        <Label
                          htmlFor={key}
                          className="col-md-4 col-form-label text-md-right p-0 m-0"
                        >
                          {key.charAt(0).toUpperCase() + key.slice(1)}
                        </Label>
                        <Col md={8}>
                          <Input
                            type="text"
                            name={key}
                            id={key}
                            className="form-control"
                            value={formData[key]}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                [e.target.name]: e.target.value,
                              })
                            }
                            readOnly={!editable}
                          />
                        </Col>
                      </Row>
                    )
                  )}
                </Form>
              </CardBody>
            </Card>
          </Col>

          {/* Password Section */}
          <Col md={{ size: 6, offset: 3 }}>
            <Card>
              <CardHeader>
                <h4>Change password</h4>
              </CardHeader>
              <CardBody>
                <Form>
                  {/* Password */}
                  <Row className="mb-3 align-items-center">
                    <Label
                      htmlFor="password"
                      className="col-md-4 col-form-label text-md-right p-0 m-0"
                    >
                      Password
                    </Label>
                    <Col md={8}>
                      <InputGroup>
                        <Input
                          type={showPassword ? "text" : "password"}
                          name="password"
                          id="password"
                          className="form-control"
                          value={formData.password}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              [e.target.name]: e.target.value,
                            })
                          }
                          readOnly={!editable}
                        />
                        <InputGroupText
                          onClick={togglePasswordVisibility}
                          style={{ cursor: "pointer" }}
                        >
                          <i className={`fas ${showPassword ? "fa-eye-slash" : "fa-eye"}`} />
                        </InputGroupText>
                      </InputGroup>
                    </Col>
                  </Row>

                  {/* Confirm Password */}
                  <Row className="mb-3 align-items-center">
                    <Label
                      htmlFor="confPassword"
                      className="col-md-4 col-form-label text-md-right p-0 m-0"
                    >
                      Confirm Password
                    </Label>
                    <Col md={8}>
                      <InputGroup>
                        <Input
                          type={showConfPassword ? "text" : "password"}
                          name="confPassword"
                          id="confPassword"
                          className="form-control"
                          value={formData.confPassword}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              [e.target.name]: e.target.value,
                            })
                          }
                          readOnly={!editable}
                        />
                        <InputGroupText
                          onClick={toggleConfPasswordVisibility}
                          style={{ cursor: "pointer" }}
                        >
                          <i className={`fas ${showConfPassword ? "fa-eye-slash" : "fa-eye"}`} />
                        </InputGroupText>
                      </InputGroup>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            </Card>
          </Col>

          {/* Action Buttons */}
          <Col md={{ size: 6, offset: 3 }}>
            <Row className="mb-4 justify-content-between pb-3">
              <Col className="d-flex justify-content-start">
                <Button
                  color={editable ? "success" : "warning"}
                  onClick={editable ? handleSubmit : () => setEditable(true)}
                >
                  {editable ? "Save Changes" : "Edit User"}
                </Button>
              </Col>
              <Col className="d-flex justify-content-end">
                <Button
                  color={editable ? "primary" : "secondary"}
                  onClick={editable ? () => setEditable(false) : () => navigate("/users")}
                >
                  {editable ? "Cancel" : "Back to users"}
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>

    </div>
  );
};

export default ViewUserPage;